import API from 'services/api';

export const getAudit = async (id) => {
  return await API.get(`/audit/${id}`);
};
